import {
	TextField,
	EmailField,
	Checkbox,
	TextLink,
	ButtonPrimary,
	ButtonLayout,
	Stack,
	Box,
	useScreenSize,
} from "@telefonica/mistica";
import React from "react";
import { isNameValid, isPhoneNumberValid } from "../../utils/validators";
import { isEmailValid } from "../../utils/validators";
import { strings } from "../../localization";
import { formatCellphoneNumber, onlyNumber } from "../../utils/formatters";
import { observer } from "mobx-react-lite";
import { useAnalytics } from "../../hooks/useAnalytics";
import { Text } from "@chakra-ui/react";
import { colors } from "../../theme/colors";

interface IProps {
	name: string;
	email: string;
	phone: string;
	selectedCheckbox: boolean;
	onNameChange(value: string): void;
	onEmailChange(value: string): void;
	onPhoneChange(value: string): void;
	onToggleCheckbox(value: boolean): void;
	onSubmit(): void;
}

export const LeadSection: React.FC<IProps> = observer((props) => {
	const {
		name,
		email,
		phone,
		selectedCheckbox,
		onNameChange,
		onEmailChange,
		onPhoneChange,
		onToggleCheckbox,
		onSubmit,
	} = props;
	const { addAnalyticEvent } = useAnalytics();
	const { isMobile } = useScreenSize();

	const areAllFieldsFilled = (): boolean => name !== "" && email !== "" && phone !== "" && selectedCheckbox;

	const { checkbox, error, labelButton, labelEmail, labelName, labelPhone, labelTerms, linkTerms, phonePrefix, title } =
		strings.components.leadSection;

	const handleAnalyticEvent = (description: string, action: string): void => {
		addAnalyticEvent(
			{
				component: "body",
				action,
				description,
				step: "fgts:simulacao-saque-aniversario",
				value: "",
			},
			{ applySanitize: true },
		);
	};
	const handleLinkOnPress = (): void => {
		handleAnalyticEvent(labelTerms, "click.link");
		window.location.href = linkTerms;
	};

	return (
		<Box paddingTop={32} paddingBottom={56}>
			<Box paddingBottom={24}>
				<Text
					fontFamily={"VivoType"}
					fontWeight="500"
					fontSize={{ base: "24px", lg: "32px" }}
					lineHeight={{ base: "32px", lg: "40px" }}
					color={colors.black[500]}
					maxW={{ base: "326px", lg: "auto" }}
				>
					{title}
				</Text>
			</Box>

			<Stack space={16}>
				<TextField
					fullWidth
					label={labelName}
					placeholder={labelName}
					name="name"
					value={name}
					onChange={(e) => {
						onNameChange(e.target.value);
					}}
					error={!isNameValid(name) && name !== ""}
					helperText={!isNameValid(name) && name !== "" ? error.name : ""}
					data-cs-mask
				/>
				<EmailField
					fullWidth
					label={labelEmail}
					placeholder={labelEmail}
					name="e-mail"
					value={email}
					onChange={(e) => {
						onEmailChange(e.target.value);
					}}
					error={!isEmailValid(email) && email !== ""}
					helperText={!isEmailValid(email) && email !== "" ? error.email : ""}
					data-cs-mask
				/>
				<TextField
					fullWidth
					maxLength={15}
					prefix={phonePrefix}
					label={labelPhone}
					placeholder={labelPhone}
					name="celular"
					value={phone}
					onChange={(e) => {
						onPhoneChange(formatCellphoneNumber(onlyNumber(e.target.value)));
					}}
					error={!isPhoneNumberValid(phone) && phone !== ""}
					helperText={phone.length !== 15 && phone !== "" ? error.phone : ""}
					data-cs-mask
				/>
			</Stack>

			<Box paddingTop={32} paddingBottom={32} className={"checkbox-simulator-lead"}>
				<Checkbox
					name="terms-accept"
					checked={selectedCheckbox}
					onChange={() => {
						handleAnalyticEvent("terms-accept", "click.checkbox");
						onToggleCheckbox(!selectedCheckbox);
					}}
				>
					{strings.formatString(checkbox.text1)}
					<TextLink onPress={handleLinkOnPress}>{labelTerms}</TextLink>
					{checkbox.text2}
				</Checkbox>
			</Box>

			<Box className="font-family-vivotype">
				<ButtonLayout align="left">
					<ButtonPrimary
						onPress={onSubmit}
						disabled={!isNameValid(name) || !isEmailValid(email) || !isPhoneNumberValid(phone) || !areAllFieldsFilled()}
						style={{ width: isMobile ? "100%" : "114px", borderRadius: "999px" }}
					>
						{labelButton}
					</ButtonPrimary>
				</ButtonLayout>
			</Box>
		</Box>
	);
});
